import { createContext } from "react";

export const backgroundColors = {
  primary: "primary",
  blue: "blue",
  purple: "purple",
  green: "green",
  gray: "#8898aa",
};

export const BackgroundColorContext = createContext({
  color: backgroundColors.blue,
  changeColor: (color) => {},
});
